import { Link } from "react-router-dom";
import { Logo } from "./logo";
import { TargetWidget } from "./target-widget";

export function Header() {
  return (
    <header className="relative flex items-center justify-between gap-2 border-b border-border bg-panel/60 backdrop-blur-sm px-3 py-2 sm:px-4 sm:py-3">
      <Link to="/" className="flex items-center gap-2 sm:gap-3 group min-w-0">
        <Logo
          size={34}
          className="shrink-0 drop-shadow-[0_0_10px_rgba(255,45,146,0.6)] sm:!w-10 sm:!h-10"
        />
        <div className="flex flex-col leading-tight min-w-0">
          <span className="font-bold tracking-widest text-accent neon-text text-xs sm:text-sm uppercase glitch-hover truncate">
            SlabScanner
          </span>
          <span className="text-[9px] sm:text-[10px] text-muted font-mono truncate">
            <span className="text-accent2">$</span> scanning slab.cash
            <span className="animate-blink text-accent ml-1">_</span>
          </span>
        </div>
      </Link>
      {/* Target reticle — compact on mobile, fuller on desktop. */}
      <div className="shrink-0 sm:hidden">
        <TargetWidget width={72} height={30} label="" />
      </div>
      <div className="shrink-0 hidden sm:block">
        <TargetWidget width={140} height={40} label="TGT" />
      </div>
    </header>
  );
}
